export const validate10Digits = (str = '') => {
	const justDigits = str.replace(/\D/g, '');
	return justDigits.split('').length === 10 || str.length === 0;
};

export const isPricingName = (str = '') =>
	['Price', 'Starting Price', 'Starting Price Range', 'Price Range'].includes(
		str,
	);
